(function(angular) {
    'use strict';

    angular.module('wtApp.wtFilterEngine', [
        'ngSanitize',
        'ngAnimate',

        'pascalprecht.translate',

        'ui.router',
        'ui.bootstrap.datepicker',
        'ui.bootstrap.position',
        'ui.bootstrap.modal',
        'ui.bootstrap.tooltip',

        'wtApp.constants',
        'wtApp.wtSelector',
        'wtApp.wtCommon',
        'wtApp.dataService',
        'wtApp.arrangeTypeInput',
        'wtApp.AbstractModal',
        'wtQueryBuilder',
        'wtUi'
    ])
        .config(['$translateProvider', '$translatePartialLoaderProvider', function($translateProvider, $translatePartialLoaderProvider) {
            $translateProvider.useLoader('$translatePartialLoader', {
                urlTemplate: 'i18n/{part}/{lang}.json'
            });
            $translateProvider.useLoaderCache('$templateCache');
            $translateProvider.preferredLanguage('en');
            $translatePartialLoaderProvider.addPart('filter-engine/filter');
        }])
        .constant('GFL_CONST', {
            SEGMENTS_ARRANGETYPE: 'segment_fake_dimension',
            SEQUENTIAL_CONNECTOR: 'THEN',
            TIME_FILTER_ARRANGE_TYPES: ['times_internal_day', 'times_dynamic'],
            DEFAULT_TIME_FILTER_INDICATOR: 'times_internal_day',
            TIME_DYNAMIC_FILTER_ARRANGE_TYPE: 'times_dynamic',
            NORMAL_FILTER_CONTEXT_NAME: 'NONE',
            CONTAINER_PREDICATE_ATTRIBUTE: 'inOrNotIn',
            CONTAINER_PREDICATE_DEFAULT_VALUE: 'IN',
            CONTAINER_SEQUENCE_INDICATOR: 'TIME_ORDER',
            ERROR_MESSAGE: 'appMessage',
            CONTEXTS: {
                AUTO: {
                    text: 'NONE',
                    value: 'NONE',
                    setsContainerType: ['NORMAL']
                },
                EXT_LIST: [{
                    text: 'ACTION',
                    value: 'ACTION',
                    setsContainerType: ['NORMAL', 'TIME_ORDER']
                }, {
                    text: 'PAGE',
                    value: 'PAGE',
                    setsContainerType: ['NORMAL', 'TIME_ORDER']
                }, {
                    text: 'SESSION',
                    value: 'SESSION',
                    setsContainerType: ['NORMAL', 'TIME_ORDER']
                }, {
                    text: 'VISITOR',
                    value: 'VISITOR',
                    setsContainerType: ['NORMAL', 'TIME_ORDER']
                }, {
                    text: 'USER_PREFERENCE',
                    value: 'VISITOR',
                    setsContainerType: ['USER_PREFERENCE']
                }]
            }
        });

    // For back compatibility
    angular.module('wtApp.groupedFilterEngine', ['wtApp.wtFilterEngine']);
})(window.angular);
